import React from 'react';
import './SeasonalEffect.css';
import './SummerWaves.css';

const WAVE_FILL_PATH =
  'M0,55 C150,77 300,33 450,55 S750,77 900,55 S1050,33 1200,55 L1200,120 L0,120 Z';

const WAVE_LAYERS = [
  { duration: 28, opacity: 0.1, bottom: '0%', height: '30vh', reverse: false },
  { duration: 20, opacity: 0.14, bottom: '0%', height: '28vh', reverse: true },
  { duration: 14, opacity: 0.08, bottom: '0%', height: '26vh', reverse: false },
];

const WAVE_FILL_MID = {
  duration: 22,
  opacity: 0.2,
  bottom: '0%',
  height: '15vh',
  reverse: true,
};

const WAVE_FILL_ACCENTS = [
  { duration: 32, opacity: 0.16, bottom: '0%', height: '13vh', reverse: false },
  { duration: 24, opacity: 0.14, bottom: '0%', height: '8vh', reverse: true },
];

function WaveFillLayer({ duration, opacity, bottom, height, reverse, className = '' }) {
  return (
    <div
      className={`wave-fill-layer ${className}`.trim()}
      style={{
        bottom,
        height,
        '--wave-opacity': opacity,
        '--wave-duration': `${duration}s`,
      }}
    >
      <svg
        className={`wave-svg-scroll${reverse ? ' wave-svg-scroll--reverse' : ''}`}
        viewBox="0 0 2400 120"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path className="wave-svg-fill" d={WAVE_FILL_PATH} />
        <path className="wave-svg-fill" d={WAVE_FILL_PATH} transform="translate(1200 0)" />
      </svg>
    </div>
  );
}

function SummerWaves() {
  return (
    <div className="seasonal-effect summer-waves" aria-hidden="true">
      {WAVE_LAYERS.map((layer, i) => (
        <WaveFillLayer key={`fill-${i}`} {...layer} />
      ))}
      <WaveFillLayer {...WAVE_FILL_MID} className="wave-fill-layer--colored" />
      {WAVE_FILL_ACCENTS.map((layer, i) => (
        <WaveFillLayer key={`accent-${i}`} {...layer} className="wave-fill-layer--colored" />
      ))}
    </div>
  );
}

export default SummerWaves;
